import React, { useEffect, useState } from 'react';
import '../../style/comment.css'
import Comment from './Comment';
import { deleteComment, getComments, postComment, updateComment } from '../../services/CommentService';
import CommentForm from './CommentForm';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

export default function Comments({blogId, currentUserId}){

    const [blogComments, setBlogComments] = useState([]);
    const [isCommentsLoading, setIsCommentsLoading] = useState(true);
    const [cookies, setCookies, removeCookies] = useCookies()
    const [activeComment, setActiveComment] = useState(null)
    const navigate = useNavigate();
    const rootComments = blogComments.filter((blogComment)=> blogComment?.parentCommentId === null)
                                     .sort((a,b)=>{return new Date(b.dateTime)-new Date(a.dateTime)});

    useEffect(()=>{
        getComments(blogId)
        .then((res)=>{
            if(res.status == 200){
                console.log(res.data)
                setBlogComments(res.data)
                setIsCommentsLoading(false)
            }
        })
        .catch((err)=>{
            if(err.response.status == 400){
                console.log("Service Unavailable")
                setIsCommentsLoading(false)
            }
        })
    }, [])
    
    const createTokenHeader = () =>{
        if(!cookies['accessToken']){
            navigate('/login')
            return
        }
        const token = cookies['accessToken'].access_token
        const _headers = {"Authorization" : `Bearer ${token}`}
        return _headers
    }

    const commentReplies = (commentId) => {
        return blogComments.filter((blogComment) => blogComment.parentCommentId === commentId)
                            .sort((a,b)=>{return new Date(a.dateTime)-new Date(b.dateTime)});
    }

    const addComment = (text, parentId=null) =>{
        const _headers = createTokenHeader();
        const commentBody = {
            content: text,
            parentCommentId: parentId,
        }

        postComment(blogId, commentBody, _headers)
        .then((res)=>{
            if(res.status == 200){
                console.log(res.data)
                setBlogComments([res.data, ...blogComments])
                setActiveComment(null)
            }
        })
        .catch((err)=>{
            if(err.response.status == 400){
                console.log("Service Unavailable")
            }
        })
    }

    const removeComment = (commentId) => {
        if(window.confirm("Do you want to delete the comment?")){
            const _headers = createTokenHeader();

            deleteComment(commentId, blogId, _headers)
            .then((res)=>{
                if(res.status == 200){
                    const updatedBlogComments = blogComments.filter((comment)=> comment._id != commentId)
                    setBlogComments(updatedBlogComments)
                    console.log("Comment Deleted")
                }
            })
            .catch((err)=>{
                if(err.response.status == 403){
                    console.log("Unauthorized Access")
                }else{
                    console.log("Service Unavailable")
                }
            })
        }
    }

    const updateCommentContent = (commentId, updatedText) => {
        const _headers = createTokenHeader();
        const commentBody = {
            commentId: commentId,
            updatedText: updatedText
        }

        updateComment(commentBody, blogId, _headers)
        .then((res)=>{
            if(res.status == 200){
                const updatedBlogComments = blogComments.map((comment)=> {
                    if(comment._id == commentId){
                        return {...comment, text: updatedText}
                    }
                    return comment;
                })
                setBlogComments(updatedBlogComments)
                console.log("Comment Updated")
                setActiveComment(null)
            }
        })
        .catch((err)=>{
            if(err.response.status == 403){
                console.log("Unauthorized Access")
            }else{
                console.log("Service Unavailable")
            }
        })
    }


    return(
        <>
        <CommentForm placeholderLabel="Write comment" submitLabel="Comment" handleSubmit={addComment}/> 
        <div style={{textAlign: 'center'}}>
            {isCommentsLoading && <CircularProgress />}
        </div>
        {!isCommentsLoading && rootComments.map((comment) => (
            <Comment
             key={comment._id} 
             comment={comment} 
             replies={commentReplies(comment._id)} 
             currentUserId={currentUserId} 
             deleteComment={removeComment}
             activeComment={activeComment}
             setActiveComment={setActiveComment}
             addComment={addComment}
             updateCommentContent={updateCommentContent}
             />
        ))}
        </>
    )
}